import { render, staticRenderFns } from "./productData.vue?vue&type=template&id=6f78e9d1&scoped=true"
import script from "./productData.vue?vue&type=script&lang=js"
export * from "./productData.vue?vue&type=script&lang=js"
import style0 from "./productData.vue?vue&type=style&index=0&id=6f78e9d1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f78e9d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f78e9d1')) {
      api.createRecord('6f78e9d1', component.options)
    } else {
      api.reload('6f78e9d1', component.options)
    }
    module.hot.accept("./productData.vue?vue&type=template&id=6f78e9d1&scoped=true", function () {
      api.rerender('6f78e9d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/logisticsSystem/stockManagement/dataQuery/productData.vue"
export default component.exports